import { useCallback, useEffect, useState } from "react";

import { getJson, payOrder } from "./money";
import { btn, C, DobSelect, dobIso, dobReady, fill, FONT, label, sel } from "./publicShared";

// "Moment" reports — bought once, at the moment a family needs them:
// detailed Kundali Milan for a proposed match (₹249) and baby names from the
// baby's birth nakshatra (₹99). Each purchase is one order with its own
// inputs (src/orders.py), so a second match is a second purchase.

const T = {
  en: {
    title: "For family moments",
    milan: "Detailed Kundali Milan", milanSub: "For a marriage proposal: all 8 gunas explained, Mangal dosha in both charts, each person's current dasha and the good years for the wedding.",
    baby: "Baby names by nakshatra", babySub: "From your baby's exact birth time: the birth star, the lucky first sound, and 20+ meaningful names that start with it.",
    start: "Start", p1: "Boy (groom)", p2: "Girl (bride)", name: "Name", dob: "Date of birth", time: "Birth time (if known)", city: "Birth place (town or city)",
    babyDob: "Baby's date of birth", babyTime: "Baby's birth time", gender: "Names for", boy: "Boy", girl: "Girl", any: "Both",
    surname: "Family name (optional)",
    timeNote: "Birth time matters — the first sound changes every few hours.",
    pay: "Pay {p} and get the report", paying: "Opening payment…", back: "← Back",
    missing: "Please fill the date of birth and birth time.",
    mine: "My family reports", open: "Open", writing: "Preparing your report — this takes up to a minute…",
    star: "Birth star", pada: "Pada", rashi: "Moon sign", sound: "Lucky first sound", others: "Other sounds from the same star",
    names: "Names", noTime: "Birth time was not given, so the first sound may not be exact.",
    k_milan_full: "Kundali Milan", k_baby_name: "Baby names", k_consult: "Astrologer chat", talk: "Talk to an astrologer about this match",
  },
  hi: {
    title: "परिवार के खास मौकों के लिए",
    milan: "विस्तृत कुंडली मिलान", milanSub: "शादी के रिश्ते के लिए: आठों गुण समझाए गए, दोनों कुंडलियों में मंगल दोष, दोनों की चल रही दशा और शादी के अच्छे वर्ष।",
    baby: "नक्षत्र से बच्चे के नाम", babySub: "बच्चे के जन्म समय से: जन्म नक्षत्र, शुभ पहला अक्षर, और उसी से शुरू होने वाले 20+ अर्थपूर्ण नाम।",
    start: "शुरू करें", p1: "लड़का (वर)", p2: "लड़की (वधू)", name: "नाम", dob: "जन्म तिथि", time: "जन्म समय (अगर पता हो)", city: "जन्म स्थान (शहर/कस्बा)",
    babyDob: "बच्चे की जन्म तिथि", babyTime: "बच्चे का जन्म समय", gender: "नाम किसके लिए", boy: "लड़का", girl: "लड़की", any: "दोनों",
    surname: "उपनाम (वैकल्पिक)",
    timeNote: "जन्म समय ज़रूरी है — हर कुछ घंटों में पहला अक्षर बदल जाता है।",
    pay: "{p} दें और रिपोर्ट पाएँ", paying: "भुगतान खुल रहा है…", back: "← वापस",
    missing: "कृपया जन्म तिथि और जन्म समय भरें।",
    mine: "मेरी पारिवारिक रिपोर्ट", open: "खोलें", writing: "आपकी रिपोर्ट तैयार हो रही है — एक मिनट तक लग सकता है…",
    star: "जन्म नक्षत्र", pada: "पद", rashi: "चंद्र राशि", sound: "शुभ पहला अक्षर", others: "उसी नक्षत्र के दूसरे अक्षर",
    names: "नाम", noTime: "जन्म समय नहीं दिया गया, इसलिए पहला अक्षर सटीक न भी हो।",
    k_milan_full: "कुंडली मिलान", k_baby_name: "बच्चे के नाम", k_consult: "ज्योतिषी चैट", talk: "इस रिश्ते पर ज्योतिषी से बात करें",
  },
  te: {
    title: "కుటుంబ సందర్భాల కోసం",
    milan: "వివరమైన కుండలి మిలన్", milanSub: "పెళ్లి సంబంధం కోసం: 8 గుణాల వివరణ, ఇద్దరి జాతకాల్లో కుజ దోషం, ఇద్దరి ప్రస్తుత దశ, పెళ్లికి మంచి సంవత్సరాలు.",
    baby: "నక్షత్రం ప్రకారం పిల్లల పేర్లు", babySub: "బిడ్డ పుట్టిన సమయం నుండి: జన్మ నక్షత్రం, శుభ మొదటి అక్షరం, దానితో మొదలయ్యే 20+ అర్థవంతమైన పేర్లు.",
    start: "మొదలుపెట్టండి", p1: "అబ్బాయి (వరుడు)", p2: "అమ్మాయి (వధువు)", name: "పేరు", dob: "పుట్టిన తేదీ", time: "పుట్టిన సమయం (తెలిస్తే)", city: "పుట్టిన ఊరు",
    babyDob: "బిడ్డ పుట్టిన తేదీ", babyTime: "బిడ్డ పుట్టిన సమయం", gender: "పేర్లు ఎవరికి", boy: "అబ్బాయి", girl: "అమ్మాయి", any: "ఇద్దరికీ",
    surname: "ఇంటి పేరు (ఐచ్ఛికం)",
    timeNote: "పుట్టిన సమయం ముఖ్యం — కొన్ని గంటలకు మొదటి అక్షరం మారుతుంది.",
    pay: "{p} చెల్లించి రిపోర్ట్ పొందండి", paying: "చెల్లింపు తెరుస్తోంది…", back: "← వెనక్కి",
    missing: "దయచేసి పుట్టిన తేదీ, సమయం నింపండి.",
    mine: "నా కుటుంబ రిపోర్టులు", open: "తెరవండి", writing: "మీ రిపోర్ట్ సిద్ధమవుతోంది — ఒక నిమిషం పట్టవచ్చు…",
    star: "జన్మ నక్షత్రం", pada: "పాదం", rashi: "చంద్ర రాశి", sound: "శుభ మొదటి అక్షరం", others: "అదే నక్షత్రం ఇతర అక్షరాలు",
    names: "పేర్లు", noTime: "పుట్టిన సమయం ఇవ్వలేదు, కాబట్టి మొదటి అక్షరం ఖచ్చితంగా ఉండకపోవచ్చు.",
    k_milan_full: "కుండలి మిలన్", k_baby_name: "పిల్లల పేర్లు", k_consult: "జ్యోతిష్య చాట్", talk: "ఈ సంబంధం గురించి జ్యోతిష్యులతో మాట్లాడండి",
  },
};

const card = { background: C.card, border: `1.5px solid ${C.border}`, borderRadius: 16, padding: 20, marginBottom: 16 };
const input = { ...sel, width: "100%", boxSizing: "border-box", padding: "0 14px" };
const PRICES = { milan_full: 249, baby_name: 99 };

export default function MomentReportsPage({ user, lang = "en", onTalk, initialKind = null }) {
  const t = T[lang] || T.en;
  const [form, setForm] = useState(initialKind);   // "milan_full" | "baby_name" | null
  const [openId, setOpenId] = useState(null);
  const [mine, setMine] = useState([]);

  const load = useCallback(() => {
    if (user?.id) getJson(`/orders/mine/${encodeURIComponent(user.id)}`)
      .then((d) => setMine((d.orders || []).filter((o) => PRICES[o.kind])), () => {});
  }, [user?.id]);
  useEffect(load, [load]);

  if (openId) return <Wrap><OrderResult t={t} user={user} lang={lang} id={openId} onTalk={onTalk} onBack={() => { setOpenId(null); load(); }} /></Wrap>;
  if (form) return <Wrap><OrderForm t={t} lang={lang} user={user} kind={form} onBack={() => setForm(null)} onPaid={(id) => { setForm(null); setOpenId(id); }} /></Wrap>;

  return (
    <Wrap>
      <h1 style={{ fontSize: 28, fontWeight: 800, margin: "0 0 16px" }}>{t.title}</h1>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 16 }}>
        {[["milan_full", t.milan, t.milanSub, "💑"], ["baby_name", t.baby, t.babySub, "👶"]].map(([k, title, sub, icon]) => (
          <div key={k} style={{ ...card, marginBottom: 0, display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ fontSize: 36 }} aria-hidden>{icon}</div>
            <h2 style={{ fontSize: 22, margin: 0 }}>{title}</h2>
            <p style={{ fontSize: 17, lineHeight: 1.55, color: C.dim, margin: 0, flex: 1 }}>{sub}</p>
            <div style={{ fontSize: 24, fontWeight: 800 }}>₹{PRICES[k]}</div>
            <button onClick={() => setForm(k)} style={btn(C.accent)}>{t.start}</button>
          </div>
        ))}
      </div>
      {mine.length > 0 && (
        <div style={{ ...card, marginTop: 20 }}>
          <h2 style={{ fontSize: 22, margin: "0 0 8px" }}>{t.mine}</h2>
          {mine.map((o) => (
            <div key={o.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderTop: `1px solid ${C.border}` }}>
              <div style={{ flex: 1, fontSize: 17 }}>
                {t[`k_${o.kind}`]}{o.kind === "milan_full" ? ` — ${o.inputs.name1} & ${o.inputs.name2}` : ` — ${o.inputs.dob}`}
              </div>
              <button onClick={() => setOpenId(o.id)} style={{ ...btn(C.accent), width: "auto", minHeight: 44 }}>{t.open}</button>
            </div>
          ))}
        </div>
      )}
    </Wrap>
  );
}

function Wrap({ children }) {
  return <div style={{ maxWidth: 980, margin: "0 auto", padding: "24px 16px 60px", fontFamily: FONT, color: C.text }}>{children}</div>;
}

function Person({ t, lang, title, v, set }) {
  return (
    <fieldset style={{ ...card, margin: "0 0 16px", maxWidth: 560 }}>
      <legend style={{ fontSize: 19, fontWeight: 800, padding: "0 6px" }}>{title}</legend>
      <label style={label}>{t.name}<input value={v.name} maxLength={40} onChange={(e) => set({ ...v, name: e.target.value })} style={{ ...input, marginTop: 6 }} /></label>
      <div style={{ ...label, marginTop: 12 }}>{t.dob}</div>
      <DobSelect lang={lang} value={v.dob} onChange={(d) => set({ ...v, dob: d })} />
      <label style={{ ...label, marginTop: 12 }}>{t.time}<input type="time" value={v.time} onChange={(e) => set({ ...v, time: e.target.value })} style={{ ...input, marginTop: 6 }} /></label>
      <label style={{ ...label, marginTop: 12 }}>{t.city}<input value={v.city} maxLength={80} onChange={(e) => set({ ...v, city: e.target.value })} style={{ ...input, marginTop: 6 }} /></label>
    </fieldset>
  );
}

const blank = () => ({ name: "", dob: { d: "", m: "", y: "" }, time: "", city: "" });

function OrderForm({ t, lang, user, kind, onBack, onPaid }) {
  const [a, setA] = useState(blank);
  const [b, setB] = useState(blank);
  const [baby, setBaby] = useState({ dob: { d: "", m: "", y: "" }, time: "", city: "", gender: "any", surname: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async () => {
    setErr("");
    let inputs;
    if (kind === "milan_full") {
      if (!dobReady(a.dob) || !dobReady(b.dob)) return setErr(t.missing);
      inputs = { name1: a.name, dob1: dobIso(a.dob), time1: a.time, city1: a.city, name2: b.name, dob2: dobIso(b.dob), time2: b.time, city2: b.city, boy: 1 };
    } else {
      if (!dobReady(baby.dob) || !baby.time) return setErr(t.missing);
      inputs = { dob: dobIso(baby.dob), time: baby.time, city: baby.city, gender: baby.gender, surname: baby.surname };
    }
    setBusy(true);
    try {
      const id = await payOrder({ user, kind, inputs, description: kind === "milan_full" ? t.milan : t.baby });
      if (id) onPaid(id);
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  return (
    <div>
      <button onClick={onBack} style={{ background: "none", border: "none", fontSize: 17, color: C.accentDark, cursor: "pointer", padding: 0, marginBottom: 16 }}>{t.back}</button>
      <h1 style={{ fontSize: 26, fontWeight: 800, margin: "0 0 16px" }}>{kind === "milan_full" ? t.milan : t.baby}</h1>
      {kind === "milan_full" ? (
        <>
          <Person t={t} lang={lang} title={t.p1} v={a} set={setA} />
          <Person t={t} lang={lang} title={t.p2} v={b} set={setB} />
        </>
      ) : (
        <div style={{ ...card, maxWidth: 560 }}>
          <div style={label}>{t.babyDob}</div>
          <DobSelect lang={lang} value={baby.dob} onChange={(d) => setBaby({ ...baby, dob: d })} />
          <label style={{ ...label, marginTop: 12 }}>{t.babyTime}<input type="time" value={baby.time} onChange={(e) => setBaby({ ...baby, time: e.target.value })} style={{ ...input, marginTop: 6 }} /></label>
          <p style={{ fontSize: 15, color: C.dim, margin: "4px 0 0" }}>{t.timeNote}</p>
          <label style={{ ...label, marginTop: 12 }}>{t.city}<input value={baby.city} maxLength={80} onChange={(e) => setBaby({ ...baby, city: e.target.value })} style={{ ...input, marginTop: 6 }} /></label>
          <div style={{ ...label, marginTop: 12 }}>{t.gender}</div>
          <div style={{ display: "flex", gap: 8 }}>
            {["boy", "girl", "any"].map((g) => (
              <button key={g} onClick={() => setBaby({ ...baby, gender: g })} aria-pressed={baby.gender === g}
                style={{ ...btn(baby.gender === g ? C.accent : C.card, baby.gender === g ? "#fff" : C.text), border: `1.5px solid ${baby.gender === g ? C.accent : C.border}` }}>{t[g]}</button>
            ))}
          </div>
          <label style={{ ...label, marginTop: 12 }}>{t.surname}<input value={baby.surname} maxLength={30} onChange={(e) => setBaby({ ...baby, surname: e.target.value })} style={{ ...input, marginTop: 6 }} /></label>
        </div>
      )}
      <button onClick={submit} disabled={busy} style={{ ...btn(C.accent), maxWidth: 560, opacity: busy ? 0.7 : 1 }}>
        {busy ? t.paying : fill(t.pay, { p: `₹${PRICES[kind]}` })}
      </button>
      {err && <p style={{ color: "#B42318", fontSize: 17 }}>{err}</p>}
    </div>
  );
}

function OrderResult({ t, user, lang, id, onBack, onTalk }) {
  const [o, setO] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    getJson(`/orders/view/${id}?user_id=${encodeURIComponent(user.id)}&lang=${lang}`).then(setO, (e) => setErr(e.message));
  }, [id, user.id, lang]);

  const back = <button onClick={onBack} style={{ background: "none", border: "none", fontSize: 17, color: C.accentDark, cursor: "pointer", padding: 0, marginBottom: 16 }}>{t.back}</button>;
  if (err) return <div>{back}<p style={{ fontSize: 18 }}>{err}</p></div>;
  if (!o || !o.result) return <div>{back}<p style={{ fontSize: 18 }}>{t.writing}</p></div>;
  const r = o.result;

  if (o.kind === "milan_full") {
    return (
      <div style={{ maxWidth: 720 }}>
        {back}
        <h1 style={{ fontSize: 26, fontWeight: 800, margin: "0 0 16px" }}>{r.title}</h1>
        {r.sections.map((s, i) => (
          <div key={i} style={{ ...card, background: i === 0 ? C.warm : C.card }}>
            <h2 style={{ fontSize: 21, margin: "0 0 10px" }}>{s.title}</h2>
            {s.body.split(/\n{2,}/).map((p, j) => <p key={j} style={{ fontSize: 18, lineHeight: 1.6, margin: "0 0 10px", whiteSpace: "pre-wrap" }}>{p}</p>)}
          </div>
        ))}
        {onTalk && <button onClick={onTalk} style={{ ...btn(C.accent), maxWidth: 520 }}>{t.talk}</button>}
      </div>
    );
  }
  const row = (k, v) => <div style={{ fontSize: 18, padding: "6px 0" }}><span style={{ color: C.dim }}>{k}: </span><b>{v}</b></div>;
  return (
    <div style={{ maxWidth: 720 }}>
      {back}
      <h1 style={{ fontSize: 26, fontWeight: 800, margin: "0 0 16px" }}>{t.baby}</h1>
      <div style={{ ...card, background: C.warm }}>
        {row(t.star, `${r.nakshatra_local}${r.nakshatra_local !== r.nakshatra ? ` (${r.nakshatra})` : ""}`)}
        {row(t.pada, r.pada)}
        {row(t.rashi, r.rashi_local)}
        <div style={{ fontSize: 18, padding: "6px 0" }}><span style={{ color: C.dim }}>{t.sound}: </span><b style={{ fontSize: 28, color: C.accentDark }}>{r.syllable}</b></div>
        {row(t.others, r.other_syllables.join(", "))}
        {!r.time_known && <p style={{ fontSize: 16, color: "#B42318" }}>{t.noTime}</p>}
      </div>
      <h2 style={{ fontSize: 22 }}>{t.names}</h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 12 }}>
        {r.names.map((n) => (
          <div key={n.name} style={{ ...card, marginBottom: 0, padding: 16 }}>
            <div style={{ fontSize: 21, fontWeight: 800 }}>{n.name}{r.surname ? ` ${r.surname}` : ""}</div>
            {n.native && n.native !== n.name && <div style={{ fontSize: 19, color: C.accentDark }}>{n.native}</div>}
            <div style={{ fontSize: 16, color: C.dim, marginTop: 4 }}>{lang === "en" ? n.meaning : (n.meaning_local || n.meaning)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
